import PurchaseOutfitContainer from '../../components/outfit/purchase-outfit-container.vue';

export default {
    path: '/purchase-outfit',
    component: PurchaseOutfitContainer,
    meta: {
        requiresAuth: true
    }
};